import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=6d4aeb01&"
import script from "./PageWrapper.vue?vue&type=script&lang=ts&"
export * from "./PageWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports